import { useState } from "react";
import DropBox from "../../../../../components/drop-box";
import RabbitFestivalCompetitionsBanner from "./components/banner";
import { useRabbitFestivalCompetitions } from "./hooks/use-festival-competitions";
import {
  FestivalCompetitionsHeader,
  FestivalCompetitionsWrapper,
} from "./style";
import RabbitFestivalCompetitionsList from "./components/list";
import { FestivalSkeletonWhiteBox } from "../../style/skeleton";
import RabbitFestivalCompetitionsListSkeleton from "./components/list/skeleton";
import { getYearList } from "../../../../../utils/date";

const RabbitFestivalCompetitions = () => {
  const { bannerCompetitions, competitions, loading, isFirst, setYear, year } =
    useRabbitFestivalCompetitions();
  const [isYear, setIsYear] = useState(false);

  return (
    <FestivalCompetitionsWrapper>
      {isFirst ? (
        <FestivalSkeletonWhiteBox width="100%" height="324px" radius="0" />
      ) : (
        <RabbitFestivalCompetitionsBanner list={bannerCompetitions} />
      )}
      <FestivalCompetitionsHeader>
        <div className="title">지난 대회</div>
        <DropBox
          value={year}
          setValue={setYear}
          label={"년"}
          isOpen={isYear}
          setIsOpen={setIsYear}
          option={getYearList()}
        />
      </FestivalCompetitionsHeader>
      {loading ? (
        <RabbitFestivalCompetitionsListSkeleton />
      ) : (
        <RabbitFestivalCompetitionsList list={competitions} />
      )}
    </FestivalCompetitionsWrapper>
  );
};

export default RabbitFestivalCompetitions;
